import { Component, Input, OnInit } from '@angular/core';
import { ICardModel } from './models/card.model';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.scss'],
})
export class CardComponent implements OnInit {
  @Input() card!: ICardModel;
  @Input() showButton = true;

  constructor() {}

  ngOnInit(): void {}
}
